// Common Constants

import { Feature } from '../models';

export const SIDEBAR_WIDTH = 300;
export const MAX_USER_NAME_LENGTH = 20;
export const MAX_ACCOUNT_NAME_LENGTH = 30;
export const USD_CURRENCY = 'USD';

// Katalon Studio download link
export const KS_DOWNLOAD_URL = 'https://katalon.com/download';

// term and policy links
export const CUSTOMER_TERM_OF_USED = 'https://katalon.com/terms#customer-terms-of-use';
export const CUSTOMER_PRIVACY_POLICY = 'https://katalon.com/terms#privacy-policy';

export const PARTNER_ID_COOKIE_NAME = 'katalon_partner_id';

export const TRACKING_QUERY_PARAMS = [
  'gaClientId',
  'gaSessionId',
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_content',
];
export const TRACKING_COOKIES = [
  '_fbp',
  '_fbc',
  ...TRACKING_QUERY_PARAMS,
];
export const PRODUCT_QUERY_PARAMS = [
  'kse_per-user_monthly',
  'kse_per-user_annual',
  'kre_floating_monthly',
  'kre_floating_annual',
  'testcloud_session_webdesktop_monthly',
  'testcloud_session_webdesktop_annual',
  'testcloud_session_mobileapp_monthly',
  'testcloud_session_mobileapp_annual',
  'testcloud_session_crossbrowser_monthly',
  'testcloud_session_crossbrowser_annual',
];

export const SUPPORTED_FEATURES = [
  Feature.TRUE_TEAM,
  Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
  Feature.TESTCLOUD_SESSION_MOBILE_APP,
  Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE,
];

export const TRUE_TESTCLOUD_ADDON_FEATURES = [
  Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
  Feature.TESTCLOUD_SESSION_MOBILE_APP,
  Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE,
];

export const DEFAULT_CURRENCY_FORMAT_OPTIONS = {
  currency: USD_CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};
